module.exports = __webpack_public_path__ + "static/media/pintor-partitura-0.acad8937.png";